import { m } from "framer-motion";
import { CalendarClock, ArrowRight } from "lucide-react";

export default function EnrollmentBanner({ onQuote }) {
  return (
    <section data-testid="enrollment-banner" className="bg-[#C85A40] text-[#F9F6F0]">
      <m.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex flex-col md:flex-row md:items-center gap-4 md:gap-8"
      >
        <div className="flex items-start md:items-center gap-3">
          <span className="flex-none w-10 h-10 rounded-full flex items-center justify-center bg-white/15">
            <CalendarClock className="w-5 h-5" />
          </span>
          <div className="leading-tight">
            <p className="font-display text-xl md:text-2xl tracking-tight" data-testid="enrollment-banner-title">
              Maryland ACA Open Enrollment 2027
            </p>
            <p className="mt-1 text-sm md:text-[15px] opacity-90 max-w-2xl" data-testid="enrollment-banner-subtitle">
              Open Enrollment begins November 1, 2026. Get personalized guidance exploring health insurance options for you
              and your family.
            </p>
          </div>
        </div>

        <button
          data-testid="enrollment-banner-cta"
          onClick={onQuote}
          className="md:ml-auto self-start md:self-auto inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold bg-[#F9F6F0] text-[#C85A40] hover:bg-white active:scale-95 transition-[background-color,transform] duration-200 whitespace-nowrap"
        >
          Get ACA Enrollment Help <ArrowRight className="w-4 h-4" />
        </button>
      </m.div>
    </section>
  );
}
